// eslint-disable-next-line import/named
import { Navigate } from "react-router-dom";

import { useStore } from "../zustand/store";

interface ILoginRouteWrapperProps {
	children: React.ReactNode;
}

export const LoginRouteWrapper = ({ children }: ILoginRouteWrapperProps) => {
	const loggedIn = useStore((state) => state.loggedIn);

	if (loggedIn) return <Navigate to="/" replace />;

	return <>{children}</>;
};
